import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=60e7b41c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=60e7b41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7b41c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e7b41c')) {
      api.createRecord('60e7b41c', component.options)
    } else {
      api.reload('60e7b41c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=60e7b41c&scoped=true&", function () {
      api.rerender('60e7b41c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8iB4P35ZhSPWp/JS/comp/PopupDialog.vue"
export default component.exports